import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Button,
  Card,
  Table,
  UncontrolledCollapse,
  CardBody,
  Row,
  Col,
  Input,
  Label,
  Tooltip,
} from "reactstrap";
import { EMPLOYEE_LIST } from "../../../constants/ApiPaths";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import Pagination from "react-js-pagination";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import {  Link } from "react-router-dom";
import { debounce } from "underscore";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import { getAgencyId } from "../../common/CommonFunctions";
import defaultAvatar from "../../../constants/Images/defaultAvatar-1.png";
import { Info } from "../../common/Info";

function Customer() {
  const [Loading, setLoading] = useState(false);
  const [Details, setDetails] = useState([]);
   let rowperpage = 10;

  const [currentpage, setCurrentPage] = useState(0);
  const [totalrecords, setTotalRecords] = useState(0);
  const [searchName, setName] = useState("");
  const [searchEmail, setEmail] = useState("");
  const [searchPhoneNumber, setPhoneNumber] = useState("+1 ");
  const { enqueueSnackbar } = useSnackbar();
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  let CustomerDetails = async (searchName, searchEmail, searchPhoneNumber) => {
    setLoading(true);
    const config = {
      method: "GET",
      url: EMPLOYEE_LIST,
      headers: authHeader(),
      params: {
        // roleId: 5,
        agencyId: getAgencyId(),
        offset: currentpage,
        count: rowperpage,
        firstName: searchName,
        email: searchEmail,
        phoneNumber:
          searchPhoneNumber && searchPhoneNumber.includes("+1")
            ? searchPhoneNumber.split("+1 ")[1]
            : searchPhoneNumber,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setDetails(data);
        setTotalRecords(totalCount);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };

  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };

  

  const onHandleNameChange = (e) => {
    const { value } = e.target;
    setName(value);
  };
  console.log("customer ph", searchPhoneNumber);
  const onHandleEmailChange = (e) => {
    const { value } = e.target;
    setEmail(value);
  };

  const onHandlePhoneChange = (e) => {
    const numericValue = e.target.value.replace(/[^0-9+\s]/g, "");
    setPhoneNumber(numericValue);
  };

  const clearButton = () => {
    setName("");
    setEmail("");
    setPhoneNumber("");
  };

  const delaySearch = useRef(
    debounce((searchName, searchEmail, searchPhoneNumber) =>
      CustomerDetails(searchName, searchEmail, searchPhoneNumber)
    )
  ).current;

  //Profile image
  let Profile = (i) => {
    const image = i.profileImage;
    if (image) {
      return image;
    } else {
      return defaultAvatar;
    }
  };

  useEffect(() => {
    delaySearch(searchName, searchEmail, searchPhoneNumber);
  }, [searchName, searchEmail, searchPhoneNumber]);

  useEffect(() => {
    CustomerDetails();
  }, [currentpage, rowperpage]);

  return (
    <div>
      <div className="agency-wrapper">
        <Container fluid>
          <div className="page-title">
            <h4>
              Customer
              <Tooltip
                isOpen={id === "viewlicense" && tooltipOpen}
                target={"viewlicense"}
                toggle={() => tooltiptoggle("viewlicense")}
              >
                View customer details
              </Tooltip>
              <span id={"viewlicense"}>
                <Info />
              </span>
            </h4>

            <div className="top-btn">
              <Button color="link" id="toggler">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14.371"
                  height="14.371"
                  viewBox="0 0 14.371 14.371"
                >
                  <path
                    id="Icon_awesome-filter"
                    data-name="Icon awesome-filter"
                    d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                    fill="#1b3e6f"
                  />
                </svg>
              </Button>
            </div>
          </div>
          {/* filter */}
          <UncontrolledCollapse toggler="#toggler" className="mt-4">
            <Card>
              <CardBody>
                <Row>
                  <Col md="3">
                    <Label>Search Name</Label>
                    <Input
                      type="text"
                      name="name"
                      value={searchName}
                      onChange={onHandleNameChange}
                      placeholder="Search Name"
                    />
                  </Col>
                  <Col md="3">
                    <Label>Search Email</Label>
                    <Input
                      type="email"
                      name="Email"
                      value={searchEmail}
                      onChange={onHandleEmailChange}
                      placeholder="Search Email"
                    />
                  </Col>
                  {console.log("ph", searchPhoneNumber)}
                  <Col md="3">
                    <Label>Search Phonenumber</Label>
                    <Input
                      type="text"
                      name="phoneNumber"
                      value={searchPhoneNumber}
                      onChange={onHandlePhoneChange}
                      placeholder="Search PhoneNumber"
                    />
                  </Col>
                  <Col md="3">
                    <Button
                      color="danger"
                      // size="sm"
                      className="mt-4"
                      onClick={clearButton}
                    >
                      Clear
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </UncontrolledCollapse>

          <Card body className="mt-4">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Loading ? <CustomPageLoading /> : ""}
                {Loading ? (
                  ""
                ) : Details.length === 0 ? (
                  <tr>
                    <td colSpan={5}>
                      <center>No Records Found</center>
                    </td>
                  </tr>
                ) : (
                  Details.map((data) => (
                    <tr>
                      <td className="customer-fname">
                        <img src={Profile(data)} alt=""/> {data.firstName}{" "}
                        {data.lastName}
                      </td>
                      <td>{data.email}</td>
                      <td>
                        {data.phoneNumber ? `+1 ${data.phoneNumber}` : ""}
                      </td>

                      <td>
                        <Link
                          to={{
                            pathname: `${"/agency/customer-details"}/${
                              data.userId
                            }`,
                          }}
                        >
                          <Button className="table-btn" color="link">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16.216"
                              height="10.811"
                              viewBox="0 0 16.216 10.811"
                            >
                              <path
                                id="Icon_awesome-eye"
                                data-name="Icon awesome-eye"
                                d="M16.118,9.494A9.03,9.03,0,0,0,8.108,4.5,9.031,9.031,0,0,0,.1,9.495a.911.911,0,0,0,0,.822,9.03,9.03,0,0,0,8.01,4.994,9.031,9.031,0,0,0,8.01-4.995A.911.911,0,0,0,16.118,9.494Zm-8.01,4.465a4.054,4.054,0,1,1,4.054-4.054A4.054,4.054,0,0,1,8.108,13.959Zm0-6.757a2.683,2.683,0,0,0-.713.107A1.347,1.347,0,0,1,5.512,9.193a2.7,2.7,0,1,0,2.6-1.99Z"
                                transform="translate(0 -4.5)"
                                fill="#1b3e6f"
                              />
                            </svg>
                          </Button>
                        </Link>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>

            <div className="d-flex flex-row py-4 justify-content-end">
              <Pagination
                itemClass="page-item"
                linkClass="page-link"
                itemsCountPerPage={rowperpage}
                totalItemsCount={totalrecords}
                activePage={currentpage + 1}
                onChange={onPageChange}
              />
            </div>
          </Card>
        </Container>
      </div>
    </div>
  );
}

export default Customer;
